/* ==========================================================================
   PRODUCT.JS — Variant selection, gallery, add-to-cart state
   ========================================================================== */
(function () {
  'use strict';

  var strings = (window.theme && window.theme.strings) || {};

  function moneyFormat(cents) {
    return window.theme.formatMoney(cents);
  }

  document.querySelectorAll('[data-product-section]').forEach(initProductSection);
  document.querySelectorAll('[data-product-section]').forEach(initStickyBuy);

  function initProductSection(section) {
    var dataEl = section.querySelector('script[data-product-json]');
    var product = null;

    if (dataEl) {
      try {
        product = JSON.parse(dataEl.textContent);
      } catch (e) {
        product = null;
      }
    }

    var lowStockThreshold = parseInt(section.getAttribute('data-low-stock'), 10) || 0;

    var isMulti = section.hasAttribute('data-multi-size');
    var selectedOptions = [];
    var variantSelect = section.querySelector('[data-variant-select]');
    if (variantSelect && variantSelect.value && product) {
      var current = product.variants.find(function (v) { return String(v.id) === String(variantSelect.value); });
      /* Multi-option products (pack) start with nothing chosen: every size must be picked on purpose. */
      if (current && !isMulti) selectedOptions = current.options.slice();
    }

    function getVariantForOptions(options) {
      if (!product) return null;
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    /* A value is "unavailable" when no sellable variant exists with it
       (keeping the other options currently chosen). */
    function isOptionAvailable(index, value) {
      if (!product) return true;
      var test = selectedOptions.slice();
      test[index] = value;
      /* An option not chosen yet (pack) matches anything. */
      return product.variants.some(function (v) {
        return v.available && v.options.every(function (opt, i) { return test[i] === undefined || opt === test[i]; });
      });
    }

    function updateOptionButtons() {
      section.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var index = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-value');
        var isSelected = value === selectedOptions[index];
        btn.classList.toggle('is-selected', isSelected);
        var unavailable = !isOptionAvailable(index, value);
        btn.classList.toggle('is-unavailable', unavailable);
        if (isMulti) {
          btn.disabled = unavailable && !isSelected;
          btn.setAttribute('aria-disabled', btn.disabled ? 'true' : 'false');
        }
      });
      section.querySelectorAll('[data-option-selected]').forEach(function (el, i) {
        el.textContent = selectedOptions[i] || '';
      });
    }

    function updateForVariant(variant) {
      var priceWrap = section.querySelector('.price');
      var stockEl = section.querySelector('[data-product-stock]');
      var addToCartBtn = section.querySelector('[data-add-to-cart]');
      var addToCartText = section.querySelector('[data-add-to-cart-text]');
      var addToCartIdInput = section.querySelector('[data-add-to-cart-id]');

      if (addToCartIdInput) addToCartIdInput.value = variant ? variant.id : '';
      if (variantSelect && variant) variantSelect.value = variant.id;

      if (!variant) {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.dataset.forceDisabled = 'true';
        }
        if (addToCartText) addToCartText.textContent = strings.unavailable || 'Unavailable';
        syncNotify(null);
        return;
      }

      if (priceWrap) {
        var currentEl = priceWrap.querySelector('.price__current');
        var compareEl = priceWrap.querySelector('.price__compare-at');
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWrap.classList.add('price--on-sale');
          if (!compareEl) {
            compareEl = document.createElement('s');
            compareEl.className = 'price__compare-at';
            priceWrap.insertBefore(compareEl, currentEl);
          }
          compareEl.textContent = moneyFormat(variant.compare_at_price);
        } else {
          priceWrap.classList.remove('price--on-sale');
          if (compareEl) compareEl.remove();
        }
        if (currentEl) currentEl.textContent = variant.price > 0 ? moneyFormat(variant.price) : (strings.comingSoon || 'Coming soon');
      }

      var max = typeof variant.inventory === 'number' ? variant.inventory : null;
      var priced = variant.price > 0;

      if (stockEl) {
        if (!variant.available) {
          stockEl.innerHTML = '<span class="stock-indicator stock-indicator--out">' + (strings.soldOut || 'Sold out') + '</span>';
        } else if (max !== null && max > 0 && max <= lowStockThreshold) {
          stockEl.innerHTML = '<span class="stock-indicator stock-indicator--low">' + (strings.lowStock || 'LOW STOCK') + '</span>';
        } else {
          stockEl.innerHTML = '';
        }
      }

      var canBuy = variant.available && priced;
      if (addToCartBtn) {
        addToCartBtn.disabled = !canBuy;
        addToCartBtn.dataset.forceDisabled = canBuy ? 'false' : 'true';
      }
      if (addToCartText) {
        if (!variant.available) addToCartText.textContent = strings.soldOut || 'Sold out';
        else if (!priced) addToCartText.textContent = strings.comingSoon || 'Coming soon';
        else addToCartText.textContent = section.getAttribute('data-add-label') || strings.addToCart || 'Add to cart';
      }

      if (variant.featured_media_id) {
        var targetSlide = section.querySelector('[data-gallery-slide][data-media-id="' + variant.featured_media_id + '"]');
        if (targetSlide) {
          selectSlide(section, targetSlide);
        }
      }

      syncNotify(variant);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    /* Pack: until every option has a size, no variant is selected and the button asks for them. */
    function packIncomplete() {
      var addToCartBtn = section.querySelector('[data-add-to-cart]');
      var addToCartText = section.querySelector('[data-add-to-cart-text]');
      var addToCartIdInput = section.querySelector('[data-add-to-cart-id]');
      var stockEl = section.querySelector('[data-product-stock]');
      var hint = section.querySelector('[data-pack-hint]');
      if (addToCartIdInput) addToCartIdInput.value = '';
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.dataset.forceDisabled = 'true';
      }
      if (addToCartText) addToCartText.textContent = section.getAttribute('data-select-sizes-text') || '';
      if (stockEl) stockEl.innerHTML = '';
      if (hint) hint.hidden = false;
      syncNotify(null);
    }

    function packComplete() {
      if (!product || !product.variants.length) return false;
      return product.variants[0].options.every(function (opt, i) { return selectedOptions[i] !== undefined; });
    }

    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      if (isMulti && btn.disabled) return;
      var index = parseInt(btn.getAttribute('data-option-index'), 10);
      selectedOptions[index] = btn.getAttribute('data-value');
      updateOptionButtons();
      if (isMulti) {
        var hint = section.querySelector('[data-pack-hint]');
        if (!packComplete()) { packIncomplete(); return; }
        if (hint) hint.hidden = true;
      }
      var variant = getVariantForOptions(selectedOptions);
      updateForVariant(variant);
    });

    /* Never submit the pack without a variant (both sizes chosen). */
    if (isMulti) {
      section.addEventListener('submit', function (e) {
        var idInput = section.querySelector('[data-add-to-cart-id]');
        if (!idInput || !idInput.value) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    /* ---------------- Back-in-stock sign-up (Klaviyo) ----------------
       Shown only for a sold-out size and only once the Klaviyo public key is set in the theme settings. The email and the
       variant id go straight to Klaviyo's client back-in-stock endpoint; Klaviyo stores the request per variant and sends the
       restock email when the variant is available again. Nothing is stored in the theme. */
    var notify = section.querySelector('[data-notify]');
    var notifyVariant = null;

    function notifyStrings() { return strings.notify || {}; }

    function setNotifyPanel(open) {
      if (!notify) return;
      var panel = notify.querySelector('[data-notify-panel]');
      var toggle = notify.querySelector('[data-notify-toggle]');
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function resetNotifyForm() {
      if (!notify) return;
      var form = notify.querySelector('[data-notify-form]');
      var err = notify.querySelector('[data-notify-error]');
      notify.querySelector('[data-notify-body]').hidden = false;
      notify.querySelector('[data-notify-success]').hidden = true;
      err.hidden = true;
      err.textContent = '';
      form.reset();
      form.dataset.busy = 'false';
    }

    function syncNotify(variant) {
      if (!notify) return;
      var enabled = !!(window.theme && window.theme.klaviyoKey);
      var show = enabled && variant && !variant.available && variant.price > 0;
      if (!show) {
        notify.hidden = true;
        notify.classList.remove('is-in');
        notifyVariant = null;
        setNotifyPanel(false);
        return;
      }
      var changed = !notifyVariant || notifyVariant.id !== variant.id;
      notifyVariant = variant;
      if (notify.hidden) {
        notify.classList.remove('is-in');
        notify.hidden = false;
        void notify.offsetWidth;
        notify.classList.add('is-in');
      }
      if (changed) {
        setNotifyPanel(false);
        resetNotifyForm();
      }
    }

    function notifyError(text) {
      var err = notify.querySelector('[data-notify-error]');
      err.textContent = text;
      err.hidden = false;
    }

    section.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-notify-toggle]');
      if (!toggle || !notify) return;
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      setNotifyPanel(open);
      if (open) {
        var input = notify.querySelector('.notify__input');
        window.setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); } }, 420);
      }
    });

    section.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-notify-form]');
      if (!form || !notify) return;
      e.preventDefault();
      var s = notifyStrings();
      var key = window.theme && window.theme.klaviyoKey;
      if (!key || !notifyVariant || form.dataset.busy === 'true') return;
      var email = form.querySelector('input[name="email"]').value.trim();
      notify.querySelector('[data-notify-error]').hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { notifyError(s.invalidEmail || 'Please enter a valid email address.'); return; }
      form.dataset.busy = 'true';
      var submit = form.querySelector('.notify__submit');
      submit.disabled = true;
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + notifyVariant.id } } }
          }
        })
      }).then(function (res) {
        form.dataset.busy = 'false';
        submit.disabled = false;
        if (res.status === 202 || res.ok) {
          notify.querySelector('[data-notify-body]').hidden = true;
          notify.querySelector('[data-notify-success]').hidden = false;
        } else if (res.status === 400) {
          notifyError(s.invalidEmail || 'Please enter a valid email address.');
        } else {
          notifyError(s.error || 'We could not save your email. Please try again in a moment.');
        }
      }).catch(function () {
        form.dataset.busy = 'false';
        submit.disabled = false;
        notifyError(s.error || 'We could not save your email. Please try again in a moment.');
      });
    });

    if (isMulti && product) {
      updateOptionButtons();
      packIncomplete();
    } else if (product && selectedOptions.length) {
      updateOptionButtons();
      syncNotify(getVariantForOptions(selectedOptions));
    }
  }

  /* ---------------- Mobile sticky buy bar ----------------
     Appears when the original ADD TO CART has scrolled off the top of the screen and goes away when it is visible again. The page
     keeps room under the footer for it (theme.css). It never talks to the cart itself: it presses the original button, so cart, stock limits and the pack's two sizes behave the same. */
  function initStickyBuy(section) {
    var bar = section.querySelector('[data-sticky-buy]');
    var origBtn = section.querySelector('[data-add-to-cart]');
    if (!bar || !origBtn) return;
    var btn = bar.querySelector('[data-sticky-buy-btn]');
    var label = bar.querySelector('[data-sticky-buy-text]');
    var priceOut = bar.querySelector('[data-sticky-buy-price]');
    var priceSrc = section.querySelector('.product-layout__head .price');
    var textEl = section.querySelector('[data-add-to-cart-text]');
    var idInput = section.querySelector('[data-add-to-cart-id]');
    var hint = section.querySelector('[data-select-hint]');
    var isMulti = section.hasAttribute('data-multi-size');
    var offscreen = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function packIncomplete() { return isMulti && (!idInput || !idInput.value); }

    function sync() {
      var current = priceSrc && priceSrc.querySelector('.price__current');
      if (current && priceOut) priceOut.textContent = current.textContent.trim();
      if (packIncomplete()) {
        label.textContent = section.getAttribute('data-add-label') || strings.addToCart || 'Add to cart';
        btn.disabled = false;
      } else {
        if (textEl) label.textContent = textEl.textContent.trim();
        btn.disabled = origBtn.disabled;
        if (hint) hint.hidden = true;
      }
    }

    function render() {
      var show = offscreen;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }

    function update() {
      /* Visible once the original button has scrolled off the top of the screen. */
      offscreen = origBtn.getBoundingClientRect().bottom < 0;
      render();
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var watcher = new MutationObserver(sync);
    watcher.observe(origBtn, { attributes: true, attributeFilter: ['disabled'] });
    if (textEl) watcher.observe(textEl, { childList: true, characterData: true, subtree: true });
    if (priceSrc) watcher.observe(priceSrc, { childList: true, characterData: true, subtree: true });
    sync();

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      if (packIncomplete()) {
        var picker = section.querySelector('[data-product-variants]');
        if (hint) hint.hidden = false;
        if (picker) {
          picker.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          picker.classList.add('is-prompting');
          window.setTimeout(function () { picker.classList.remove('is-prompting'); }, 1800);
        }
        return;
      }
      /* The original button submits the form exactly as usual (always one unit). */
      origBtn.click();
    });
  }

  /* ---------------- Gallery ---------------- */
  function selectSlide(section, targetSlide) {
    var slides = section.querySelectorAll('[data-gallery-slide]');
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');
    var index = Array.prototype.indexOf.call(slides, targetSlide);
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    targetSlide.classList.add('is-active');
    if (thumbs[index]) thumbs[index].classList.add('is-active');
  }

  /* Mobile gallery is a horizontal swipe track (one photo at a time). Keep the active slide / thumbnail in step with the
     scroll position, and scroll to the slide chosen by thumbnails, arrows or a variant change. On desktop the photos sit in a
     two-column grid, the track never overflows and this does nothing. */
  document.querySelectorAll('[data-gallery-main]').forEach(function (track) {
    var slides = track.querySelectorAll('[data-gallery-slide]');
    if (slides.length < 2) return;
    var section = track.closest('[data-product-section]');
    var timer;
    function isTrack() { return track.scrollWidth > track.clientWidth + 1; }
    track.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (!isTrack()) return;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (slides[i] && !slides[i].classList.contains('is-active')) selectSlide(section, slides[i]);
      }, 90);
    }, { passive: true });
    new MutationObserver(function () {
      if (!isTrack()) return;
      var active = track.querySelector('[data-gallery-slide].is-active');
      if (active && Math.abs(track.scrollLeft - active.offsetLeft) > 2) {
        track.scrollTo({ left: active.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }).observe(track, { attributes: true, attributeFilter: ['class'], subtree: true });
  });

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-product-gallery]');
      var index = parseInt(thumb.getAttribute('data-index'), 10);
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      if (slides[index]) selectSlide(gallery, slides[index]);
      return;
    }

    var next = e.target.closest('[data-gallery-next]');
    var prev = e.target.closest('[data-gallery-prev]');
    if (next || prev) {
      var galleryEl = (next || prev).closest('[data-product-gallery]');
      var slideList = galleryEl.querySelectorAll('[data-gallery-slide]');
      var currentIndex = Array.prototype.findIndex.call(slideList, function (s) { return s.classList.contains('is-active'); });
      var newIndex = next ? (currentIndex + 1) % slideList.length : (currentIndex - 1 + slideList.length) % slideList.length;
      selectSlide(galleryEl, slideList[newIndex]);
    }
  });
})();
